import React from 'react'

import Modal from '@components/Modal'
import { Formik, Form, Field } from '@components/Form'

import { Button } from './styles'

const RadiusInfo = ({ submit }) => (
  <Modal title="Informe o raio" width="200px" onClose={submit}>
    <Formik initialValues={{ radius: 250 }} onSubmit={submit}>
      {({ handleChange, handleSubmit, values }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            type="number"
            name="radius"
            label="Raio"
            value={values.radius}
            onChange={handleChange}
          />
          <Button type="submit">Aplicar</Button>
        </Form>
      )}
    </Formik>
  </Modal>
)

export default RadiusInfo
